export default __webpack_public_path__ + "static/media/319.7b6dfc28.jpg";